module.exports = __webpack_public_path__ + "img/align_right_icon.5e44b837.svg";